@app.filter "priceConversion", ->
  (text) ->
    parseFloat(text)/100.0
